import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rider-policy',
  templateUrl: './rider-policy.component.html',
  styleUrls: ['./rider-policy.component.css']
})
export class RiderPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
